import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Address, JobCategory, Page, Search, User, SortDirection } from 'orv-ui-base-lib';

@Component({
	selector: 'app-assign-to-modal',
	templateUrl: './assign-to-modal.component.html',
	styleUrls: ['./assign-to-modal.component.scss']
})
export class AssignToModalComponent implements OnInit {

	@Output() save: EventEmitter<User> = new EventEmitter<User>();
	@Output() cancel: EventEmitter<any> = new EventEmitter<any>();
	
	page: Page = new Page();

	selectedUser: User;
	
	userEntityClass: ClassType<User> = User;
	advancedSearch: Search = new Search('orvuser');

	constructor() { }

	ngOnInit() {
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
		this.advancedSearch.addNotEqualFilter('jobcategory', JobCategory.DRIVER);
	}

	onUserChange(event: User) {
		this.selectedUser = event;
	}

	submit() {
		this.save.emit(this.selectedUser);
	}

	reset() {
		this.cancel.emit();
	}
}
